






































































import { Component, Vue, Prop } from 'vue-property-decorator';
import { SmartQuery } from 'vue-apollo-decorator';

import { GQL_currentUnit_currentUnit } from '@/queries/__generated__/currentUnit';
import {
  GQL_ameldingReconciliationReports,
  GQL_ameldingReconciliationReports_ameldingReconciliationReports,
  GQL_ameldingReconciliationReportsVariables,
} from '@/queries/__generated__/ameldingReconciliationReports';
import gql from 'graphql-tag';

const AMELDING_RECONCILIATION_REPORT_LIST = gql`
  query ameldingReconciliationReports($unitId: ID!, $year: String!) {
    ameldingReconciliationReports(unitId: $unitId, year: $year) {
      id
      calendarMonth
      ameldingReconciliationReference
      altinnSubmission{
        id
        humanStatus
        receiptText
        sentAt
        sentBy {
          id
          name
        }
        archivedAt
      }
      altinn3Submission{
        id
        humanStatus
        sentAt
        sentBy {
          id
          name
        }
      }
    }
  }
`;

// Altinn2 is retired, so no new reconciliation reports can be ordered through
// it. This only lists the ones ordered before the retirement; new ones are
// uploaded manually.
@Component
export default class AmeldingReconciliationReportList extends Vue {
  @Prop(Object) private currentUnit!: GQL_currentUnit_currentUnit;
  @Prop({ type: Number, required: true }) private year!: string;

  private showAll = false;

  @SmartQuery<AmeldingReconciliationReportList, GQL_ameldingReconciliationReports, GQL_ameldingReconciliationReportsVariables>({
    query: AMELDING_RECONCILIATION_REPORT_LIST,
    fetchPolicy: 'network-only',
    variables() {
      return {
        year: String(this.year),
        unitId: this.currentUnit.id,
      };
    },
  }) private ameldingReconciliationReports!: GQL_ameldingReconciliationReports_ameldingReconciliationReports[];

  private get viewAmeldingReconciliationReports() {
    if (this.showAll) return this.ameldingReconciliationReports;

    const mostRecentRequest: { [calendarMonth: string]: GQL_ameldingReconciliationReports_ameldingReconciliationReports } = {};
    this.ameldingReconciliationReports.forEach((report) => {
      if (
        !mostRecentRequest[report.calendarMonth] ||
        mostRecentRequest[report.calendarMonth].altinnSubmission!.sentAt < report.altinnSubmission!.sentAt
      ) {
        mostRecentRequest[report.calendarMonth] = report;
      }
    });

    return Object.values(mostRecentRequest);
  }
}
